"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductPromotionsMaterialPriceEditModel = instanceOfProductPromotionsMaterialPriceEditModel;
exports.ProductPromotionsMaterialPriceEditModelFromJSON = ProductPromotionsMaterialPriceEditModelFromJSON;
exports.ProductPromotionsMaterialPriceEditModelFromJSONTyped = ProductPromotionsMaterialPriceEditModelFromJSONTyped;
exports.ProductPromotionsMaterialPriceEditModelToJSON = ProductPromotionsMaterialPriceEditModelToJSON;
exports.ProductPromotionsMaterialPriceEditModelToJSONTyped = ProductPromotionsMaterialPriceEditModelToJSONTyped;
/**
 * Check if a given object implements the ProductPromotionsMaterialPriceEditModel interface.
 */
function instanceOfProductPromotionsMaterialPriceEditModel(value) {
    if (!('wsppmPromotionsMaterialNo' in value) || value['wsppmPromotionsMaterialNo'] === undefined)
        return false;
    if (!('wspmdMaterialPrice' in value) || value['wspmdMaterialPrice'] === undefined)
        return false;
    return true;
}
function ProductPromotionsMaterialPriceEditModelFromJSON(json) {
    return ProductPromotionsMaterialPriceEditModelFromJSONTyped(json, false);
}
function ProductPromotionsMaterialPriceEditModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'wsppmPromotionsMaterialNo': json['wsppmPromotionsMaterialNo'],
        'wspmdMaterialPrice': json['wspmdMaterialPrice'],
        'wspmdCalculation': json['wspmdCalculation'] == null ? undefined : json['wspmdCalculation'],
    };
}
function ProductPromotionsMaterialPriceEditModelToJSON(json) {
    return ProductPromotionsMaterialPriceEditModelToJSONTyped(json, false);
}
function ProductPromotionsMaterialPriceEditModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'wsppmPromotionsMaterialNo': value['wsppmPromotionsMaterialNo'],
        'wspmdMaterialPrice': value['wspmdMaterialPrice'],
        'wspmdCalculation': value['wspmdCalculation'],
    };
}
